import {
  ORG_ID_ROUTE_TOKEN,
  ORG_SCOPED_ROUTE_PREFIXES,
  ROUTE_SEGMENT,
  type OrgScopedRoutePrefix,
} from './const';

export const isOrgScopedPathname = (pathname: string): boolean =>
  ORG_SCOPED_ROUTE_PREFIXES.some(prefix => pathname.startsWith(`/${prefix}/`));

export const getOrgScopedPrefix = (
  pathname: string
): OrgScopedRoutePrefix | null => {
  for (const prefix of ORG_SCOPED_ROUTE_PREFIXES) {
    if (pathname.startsWith(`/${prefix}/`)) return prefix;
  }

  return null;
};

export const getOrgIdFromPathname = (pathname: string): string | null => {
  const prefix = getOrgScopedPrefix(pathname);
  if (!prefix) return null;

  const rest = pathname.slice(`/${prefix}/`.length);

  return rest.split('/')[0] || null;
};

export const isOrgScopedDetailPathname = (pathname: string): boolean => {
  const prefix = getOrgScopedPrefix(pathname);
  if (!prefix) return false;

  const rest = pathname.slice(`/${prefix}/`.length);
  const [, ...detailSegments] = rest.split('/').filter(Boolean);

  return detailSegments.length > 0;
};

export const replaceOrgInPathname = (
  pathname: string,
  newOrgId: string
): string => {
  const prefix = getOrgScopedPrefix(pathname);
  if (!prefix) return pathname;

  const rest = pathname.slice(`/${prefix}/`.length);
  const segments = rest.split('/');

  segments[0] = newOrgId;

  return `/${prefix}/${segments.join('/')}`;
};

export const resolveOrgSwitchTargetPath = (
  pathname: string,
  newOrgId: string
): string | null => {
  const prefix = getOrgScopedPrefix(pathname);
  if (!prefix) return null;

  if (isOrgScopedDetailPathname(pathname)) {
    return `/${prefix}/${newOrgId}`;
  }

  return replaceOrgInPathname(pathname, newOrgId);
};

export const buildOrgScopedPath = (
  prefix: OrgScopedRoutePrefix,
  orgId: string,
  ...restSegments: string[]
): string => `/${prefix}/${[orgId, ...restSegments].join('/')}`;

export const buildAgentsPath = (
  orgId: string,
  ...restSegments: string[]
): string => buildOrgScopedPath(ROUTE_SEGMENT.AGENTS, orgId, ...restSegments);

export const buildConversationPath = (
  orgId: string,
  ...restSegments: string[]
): string =>
  buildOrgScopedPath(ROUTE_SEGMENT.CONVERSATION, orgId, ...restSegments);

export const buildBillingPath = (
  orgId: string,
  ...restSegments: string[]
): string => buildOrgScopedPath(ROUTE_SEGMENT.BILLING, orgId, ...restSegments);

export const resolveMenuItemUrl = (
  url: string | undefined,
  orgId: string
): string => {
  if (!url) return '/';

  return url.replace(ORG_ID_ROUTE_TOKEN, orgId);
};
